import { InjectionToken, InputSignal, TemplateRef, Type } from '@angular/core';
import { encode } from 'universal-base64url';
import { FilterOperator, SortQuery } from '../../api/api.operators';

export const APP_FILTER_SERVICE_CONFIG =
  new InjectionToken<FilterServiceConfig>('FilterService Configuration');
export const APP_FILTER_CONFIG = new InjectionToken<FilterData[]>(
  'Filter Configurations',
);
export const APP_FILTER_VIEWS = new InjectionToken<Record<string, string[]>>(
  'Preset table views',
);

export interface FilterQueryParams {
  filters: Record<string, any>;
  filterStates: Record<string, any>;
  sorts: SortQuery[];
  search: string;
}

export interface FilterServiceConfig {
  defaults?: Partial<Omit<FilterQueryParams, 'filterStates'>>;
  key?: string;
  syncUrl?: boolean;
}

export interface FilterData {
  name: string;
  label: string;
  suffix?: string;
  component: Type<any>;
  preset?: boolean;
  template?: TemplateRef<any>;
  extraInputs?: Record<string, any>;
  sortable?: boolean;
}

export interface FilterComponent {
  appFilter: InputSignal<string>;
  appFilterOperators: InputSignal<FilterOperator[] | undefined>;
  appFilterNotOperators: InputSignal<FilterOperator[] | undefined>;
}

export enum SortState {
  None,
  Ascending,
  Descending,
}

export function getFilterKey(filter: FilterData) {
  return filter.name + (filter.suffix ?? '');
}

export function getParamsForFilters(filters: Record<string, any>): string {
  if (!filters || !Object.keys(filters).length) return '';
  return encode(JSON.stringify(filters));
}
